import { createElement } from "react";
import { useModal } from "@app/hooks";
import { MODALS_MAP } from "./constants";

export const Modals = () => {
  const { modalState } = useModal();

  return MODALS_MAP[modalState] ? createElement(MODALS_MAP[modalState]) : null;
};
